import { render, staticRenderFns } from "./before-page.vue?vue&type=template&id=3bc15ff9&scoped=true&"
import script from "./before-page.vue?vue&type=script&lang=js&"
export * from "./before-page.vue?vue&type=script&lang=js&"
import style0 from "./before-page.vue?vue&type=style&index=0&id=3bc15ff9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc15ff9",
  null
  
)

export default component.exports